<script lang="ts">
    export default {
        name: 'Select',

        props: {
            value: {
                type: [String, Number],
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                // eslint-disable-next-line vue/no-reserved-keys
                _tomSelect: null,
            };
        },

        mounted() {
            this._tomSelect = new window.TomSelect(this.$refs.select, {
                hideSelected: false,
                maxOptions: null,
                dropdownParent: 'body',
            });
        },

        beforeDestroy() {
            if (this._tomSelect) {
                this._tomSelect.destroy();
            }
        },
    };
</script>

<template>
    <div :class="{'has-value': value}">
        <select
            v-once
            ref="select"
            :disabled="disabled"
            :value="value"
            @change="(event) => $emit('input', event.target.value)"
        >
            <slot/>
        </select>
        <slot name="label"/>
    </div>
</template>
